import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/Sli/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Shipper’s Letter of Instruction</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            If you have ever had a shipment delayed because the forwarder didn't know who to bill or
            where to send the documents, you know why the Shipper’s Letter of Instruction (SLI) exists.
            It’s the "master instruction" from the exporter to the forwarder. It eliminates the guessing
            game. By filling this out, the shipper tells the forwarder exactly how to handle the shipment,
            often acting as a limited Power of Attorney to file export declarations on their behalf.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;